import { Modules } from '@enum/central/modules.enum';
import { TenantPerm } from '@enum/tenant/permission/tenant-perm.enum';
import { CommonPerm } from '@enum/common/permission/common-perm.enum';

export const AdministrativeSection = [
  {
    section: 'Administrativo',
    permission: [
      '*',
      TenantPerm.Clients_View,
      TenantPerm.Providers_View,
      // União das telas da seção: `Partners_View` (Sócios, dentro de Pessoas)
      // faltava, e quem só tinha ele via o item sem o título da seção.
      TenantPerm.Employees_View, TenantPerm.Interns_View, TenantPerm.Partners_View,
      CommonPerm.Users_View,
      TenantPerm.AdminDocuments_View, TenantPerm.Contracts_View,
    ],
  },
  {
    title: 'Clientes',
    permission: ['*', TenantPerm.Clients_View],
    root: true,
    icon: 'person',
    page: '/painel/listagem/clientes',
    bullet: 'dot',
  },
  {
    title: 'Fornecedores',
    permission: ['*', TenantPerm.Providers_View],
    root: true,
    icon: 'handshake',
    page: '/painel/listagem/fornecedores',
    bullet: 'dot',
  },
  {
    // "Pessoas", e não "Colaboradores" (dono, 06/09/2026): colaborador é o
    // eufemismo de EMPREGADO, e sócio não é empregado — é dono. No vocabulário
    // contábil isso é quadro societário, que existe em oposição ao quadro de
    // funcionários, então o rótulo antigo tropeçava justamente com quem mais
    // usa o sistema. "Pessoas" cobre os três sem mentir sobre nenhum, e
    // continua valendo se entrar prestador ou terceiro.
    title: 'Pessoas',
    root: true,
    icon: 'group',
    bullet: 'dot',
    permission: ['*', TenantPerm.Employees_View, TenantPerm.Interns_View, TenantPerm.Partners_View],
    submenu: [
      {
        title: 'Estagiários',
        permission: ['*', TenantPerm.Interns_View],
        root: true,
        page: '/painel/listagem/estagiarios',
        bullet: 'dot',
      },
      {
        title: 'Funcionários',
        permission: ['*', TenantPerm.Employees_View],
        root: true,
        page: '/painel/listagem/funcionarios',
        bullet: 'dot',
      },
      // Sócios (dono, 06/09/2026): entra em Colaboradores porque é ali que o
      // usuário procura pessoa da empresa, e porque os três servem de base
      // para criar usuário do sistema.
      {
        title: 'Sócios',
        permission: ['*', TenantPerm.Partners_View],
        root: true,
        page: '/painel/listagem/socios',
        bullet: 'dot',
      },
    ],
  },
  {
    title: 'Usuários do sistema',
    permission: ['*', CommonPerm.Users_View],
    icon: 'person_edit',
    page: '/painel/listagem/usuarios',
    bullet: 'dot',
  },
  {
    title: 'Contratos',
    module: Modules.CONTRACTS,
    permission: ['*', TenantPerm.Contracts_View],
    root: true,
    // Era 'description' (dono, 22/09/2026: ícone único por item do menu —
    // repetia com "Certificado digital" e os dois "Documentos"). `contract_edit`
    // é o desenho de contrato do catálogo, e `handshake` já é de "Fornecedores".
    icon: 'contract_edit',
    bullet: 'dot',
    page: '/painel/contratos',
  },
  {
    title: 'Documentos',
    permission: ['*', TenantPerm.AdminDocuments_View],
    root: true,
    // Era 'description' — mesmo motivo acima. Estes são documentos de PESSOAS
    // e EMPRESAS (cliente/fornecedor/funcionário), por isso `folder_shared`;
    // não confundir com "Documentos" da Contabilidade, que continua com
    // `description` (arquivo genérico) por ser outra coisa.
    icon: 'folder_shared',
    bullet: 'dot',
    page: '/painel/documentos-administrativos',
  }
];
